import React from 'react';
import {
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialog,
  ModalDialogContent,
  ModalDialogBody,
  ModalDialogNav,
  ModalDialogFooter,
  Button,
  Typography,
} from '@vp/swan';

import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';

export const CustomIframeDisplay = ({ attribute }) => {
  const [cartMessages, sharedActionMessages] = useTranslations([
    'cartMessages',
    'sharedActionMessages',
  ]);

  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const IFRAME_HEIGHT = 300;
  const IFRAME_WIDTH = '100%';
  const label = attribute.label ? attribute.label : cartMessages.moreContent;

  return (
    <>
      <ModalDialog
        isOpen={modalIsOpen}
        onRequestDismiss={() => setModalIsOpen(false)}
        variant="standard"
      >
        <ModalDialogContent>
          <ModalDialogNav>
            <ModalDialogCloseButton
              visuallyHiddenLabel={sharedActionMessages.close}
            />
          </ModalDialogNav>
          <Typography
            fontSize="large"
            fontWeight="bold"
            marginTop="5"
            marginBottom="5"
          >
            {label}
          </Typography>
          <ModalDialogBody>
            <iframe
              src={attribute.data}
              frameBorder={0}
              width={IFRAME_WIDTH}
              height={IFRAME_HEIGHT}
              title={attribute.label + attribute.data}
            />
          </ModalDialogBody>
          <ModalDialogFooter>
            <ModalDialogButtons>
              <Button
                size="mini"
                width="full-width"
                skin="secondary"
                onClick={() => setModalIsOpen(false)}
              >
                {sharedActionMessages.close}
              </Button>
            </ModalDialogButtons>
          </ModalDialogFooter>
        </ModalDialogContent>
      </ModalDialog>
      <Button skin="link" onClick={() => setModalIsOpen(true)}>
        {label}
      </Button>
    </>
  );
};

CustomIframeDisplay.propTypes = {
  attribute: PropTypes.object.isRequired,
};
